var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"small":"","color":"rgba(255, 255, 255, 0.15)"},on:{"click":_vm.submitLogout}},[_c('v-icon',{staticClass:"mr-2",attrs:{"small":""}},[_vm._v("mdi-logout")]),_vm._v(" 로그아웃 ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }